const constants = {
  403: {
    titleText: 'Invalid Credentials',
    mainText: 'We cannot log you in.',
    subText: 'Please check your credentials and try again.',
  },
  404: {
    titleText: 'Page not found',
    mainText: 'Requested page not found.',
    subText: 'Please check the page URL address and try again.',
  },
  424: {
    titleText: 'Invalid invite code',
    mainText: 'Incorrect code limit reached.',
    subText: 'Please reach out to your care team to receive a new invite code.',
  },
  500: {
    titleText: 'System Error',
    mainText: 'Something went wrong.',
    subText:
      'Check back later.  If error persists, please contact the application support team for assistance.',
  },
};

export default constants;
